<p-dialog
  [header]="getHeader()"
  [(visible)]="visible"
  [style]="{ width: '100%', maxWidth: '700px' }"
  [contentStyle]="{ minHeight: 'calc(100vh - 750px)' }"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [focusOnShow]="false"
  [closable]="!forceChange"
>
  <div class="flex flex-column gap-3">
    <p-messages
      severity="info"
      [(value)]="message"
      [enableService]="false"
      [closable]="false"
      [escape]="false"
      [styleClass]="'accessible-info-msg custom-accessible-message'"
    >
    </p-messages>
    <eo-form
      #eoForm
      [config]="getFormConfig()"
      (formSubmit)="onSubmit($event)"
      [submitButtonLoading]="isSubmitLoading()"
      [submitButtonLabel]="'Αλλαγή Κωδικού'"
      [submitButtonStyleClass]="'p-button-sm p-button-primary'"
    />
  </div>
</p-dialog>
